export enum VideoPlayerErrorTitles {
  Youtube = "YouTube Player error",
  Vimeo = "Vimeo Player error",
  Html5 = "HTML5 Player error",
}

export enum VideoPlayerErrorMessages {
  Unknown = "Unknown error",
  Play = "Error playing video",
  Load = "Error loading video",
}

export enum VideoPlayerErrorTypes {
  RequiredId = "RequiredVideoId",
  InvalidUrl = "InvalidVideoUrl",
  Play = "PlayVideoError",
  Load = "LoadVideoError"
}

export enum VimeoPlayerErrorMessages {
  RequiredId = "Vimeo video id is required",
  InvalidUrl = "Vimeo video url is not valid",
}

export enum YoutubePlayerErrorMessages {
  RequiredId = "YouTube video id is required",
  InvalidUrl = "YouTube video url is not valid",
}

// Vimeo player error known names:
// UnsupportedError
// PasswordError
// PrivacyError
// RangeError
// InvalidCuePoint
// InvalidTrackLanguageError
// InvalidTrackError
// TypeError
// EmbedSettingsError
// PlaybackError
// PlayInterrupted
// AbortError
// ...

// YouTube player known error types:
// InvalidParam
// Html5Error
// VideoNotFound
// EmbeddingNotAllowed
// EmbeddingNotAllowed2
